import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Route, Switch } from 'react-router-dom';

import LayoutContainer from '../../containers/Layout';
import SuccessDialog from '../../components/dialogs/SuccessDialog';
import ErrorDialog from '../../components/dialogs/ErrorDialog';

//- Pages / Route
import DriverReport from './DriverReport';
import DeliveryTicket from './DeliveryTicket';
import DriverDeliveryTickets from './DriverDeliveryTickets';
import DeliveryTicketFromMove from './DeliveryTicketFromMove';

const styles = () => {
	return {
		root: {
			backgroundColor: 'white',
		},
	};
};

const NoMatch = () => (
	<div>
		<h2>Invalid URL. Please check your URL again or contact support.</h2>
	</div>
);

class PrintableLayout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isSuccessDialogOpen: false,
			isErrorDialogOpen: false,
		};
	}

	handleSuccessClose = () => {
		this.props.clearSuccess();
		this.props.history.push(this.props.onSuccessRedirectTo);
	};

	render() {
		// noinspection JSMismatchedCollectionQueryUpdate
		const { classes, successMessages = [], errorMessages = [] } = this.props;

		const isSuccessDialogOpen = successMessages.length !== 0;
		const isErrorDialogOpen = errorMessages.length !== 0;

		return (
			<div className={classes.root}>
				<Switch>
					<Route
						exact
						path="/printable/driverReport/:driverReportId/:accessToken?"
						component={DriverReport}
					/>

					<Route
						exact
						path="/printable/deliveryTicket/:stopNumber/:accessToken?"
						component={DeliveryTicket}
					/>

					<Route
						exact
						path="/printable/deliveryTicketFromMove/:geoTabName/:moveNumber/:accessToken?"
						component={DeliveryTicketFromMove}
					/>

					<Route
						exact
						path="/printable/driverDeliveryTickets/:userId/:accessToken?"
						component={DriverDeliveryTickets}
					/>

					<Route
						exact
						path="/printable/driverDeliveryTicketsWithOverride/:userId/:overrideShiftDate?/:accessToken?"
						component={DriverDeliveryTickets}
					/>

					<Route component={NoMatch} />
				</Switch>

				<ErrorDialog
					onClose={this.props.clearError}
					errorMessages={errorMessages}
					open={isErrorDialogOpen}
				/>

				<SuccessDialog
					onClose={this.handleSuccessClose}
					successMessages={successMessages}
					open={isSuccessDialogOpen}
				/>
			</div>
		);
	}
}

PrintableLayout.propTypes = {
	classes: PropTypes.object.isRequired,
	onSuccessRedirectTo: PropTypes.string,
	successMessages: PropTypes.array,
	errorMessages: PropTypes.array,
	clearError: PropTypes.func,
	clearSuccess: PropTypes.func,
	history: PropTypes.object,
};

export default _.flow([withStyles(styles), LayoutContainer])(PrintableLayout);
